window.fetchData = function (query) {
    return new Promise(function (resolve, reject) {
        axios.post('/api/graphql/query/web', {
            query: query,
        }).then(function (response) {
            resolve(response.data.data);
        }).catch(function (err) {
            reject(err);
        });
    });
};
